import { isCheckoutBlockedByWarnings } from '@insurance/utils'
import { Form } from 'antd'

import { InsurancePaymentControls } from '../InsurancePaymentControls'

import { useGreenCardInsuranceValues } from './GreenCardInsuranceContext'
import { GreenCardFormValues } from './types'
import {
  formProps,
  normalizeOrderData,
  removeGreenCardValuesFromStorage
} from './utils'

type Props = {
  steps: number
  onReadyToSaveData?: () => void
}

export const GreenCardInsuranceControls = ({
  steps,
  onReadyToSaveData
}: Props) => {
  const { handleCalculate, isCalculatingLoading, order } =
    useGreenCardInsuranceValues()
  const { orderKey, warningsKey } = formProps()

  const underwritingWarnings = Form.useWatch(warningsKey.name, {
    preserve: true
  })

  const isCheckoutBlocked = isCheckoutBlockedByWarnings(underwritingWarnings)

  return (
    <InsurancePaymentControls
      steps={steps}
      onReadyToSaveData={onReadyToSaveData}
      removeFromStorage={() => removeGreenCardValuesFromStorage(order?.id)}
      handleCalculate={handleCalculate}
      isCalculatingLoading={isCalculatingLoading}
      errorUnwrapKeys={['green_card']}
      normalizeOrderData={(values) => ({
        id: values[orderKey.name] as number,
        requestBody: {
          green_card: normalizeOrderData(values as GreenCardFormValues)
        }
      })}
      disabledPay={isCheckoutBlocked}
    />
  )
}
